export const logErrorAndGetEmptyString = (e: Error) => {
	console.error('Error: ', e.message)
	return ''
}

export const logErrorWithCustomReturn = (returnItem: any)=> (e: Error) =>{
	console.error('Error: ', e.message)
	return returnItem
}

export const simpleErrorLogger = (e: Error) => {
	console.error('Error: ', e.message)
}